/**
 * The only valid characters for an @emotion key are lower case chars or '-'.
 * We need to replace any char that is not valid with a substitute.
 */
export const makePopoutId = (str: string): string =>
  str
    .toLowerCase()
    .replaceAll(/[^a-z0-9-]/g, '-')
    .replaceAll('0', '-zero-')
    .replaceAll('1', '-one-')
    .replaceAll('2', '-two-')
    .replaceAll('3', '-three-')
    .replaceAll('4', '-four-')
    .replaceAll('5', '-five-')
    .replaceAll('6', '-six-')
    .replaceAll('7', '-seven-')
    .replaceAll('8', '-eight-')
    .replaceAll('9', '-nine-')
    .replaceAll(/-+/g, '-')
    .toLowerCase();

export const popoutWindowDivId = (windowTitle: string): string => `popoutWindow-${makePopoutId(windowTitle)}`;
